module.exports = __webpack_public_path__ + "img/сlockwise-vertical-arrows.743c816b.png";